import angular from 'angular';

angular.module('evl-waiting');

class rejectEnvelopeModalCtrl {
  /* @ngInject */
  constructor(LadProviderService) {
    this.LadProviderService = LadProviderService;
  }

  $onInit() {
    this.criteria = { motif: null };
  }

  ok() {
    if (this.form.$valid) {
      this.modalInstance.close(this.criteria.motif);
    }
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}

angular.module('evl-waiting').component('rejectEnvelopeModal', {
  templateUrl: require('./reject-evl-modal.html'),
  controller: rejectEnvelopeModalCtrl,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
});
